import * as React from 'react';
import {useFormikContext} from 'formik';
import Row from 'components/Row';
import Column from 'components/Column';
import FormContainer from '../../containers/FormContainer';
import {DatePicker} from 'components/DatePicker';
import {WebinarObject} from 'api/webinar/types';
import {DatePickerDateArg} from "components/DatePicker/DatePicker";

/**
 * The date form part
 * @return {React.ReactElement}
 * @constructor
 */
export default function DateForm(): React.ReactElement {
  const formContext = useFormikContext<Partial<WebinarObject>>();

  /**
   * Render content
   * @return {JSX.Element}
   */
  function renderContent(): JSX.Element {
    /**
     * Handle date change
     * @param {DatePickerDateArg} date
     */
    function handleChange(date: DatePickerDateArg) {
      formContext.setFieldValue('date', date);
      formContext.submitForm();
    }

    return (
      <React.Fragment>
        <Row>
          <Column>
            <Row>
              <Column>
                <DatePicker
                  label="Дата и время начала"
                  minDate={new Date()}
                  selected={formContext.values.date}
                  startDate={formContext.values.date}
                  onChange={handleChange}
                  dateFormat="dd.MM.yyyy в HH:mm"
                  timeIntervals={15}
                  timeFormat="HH:mm"
                  showTimeSelect
                  required
                />
              </Column>
            </Row>
          </Column>
        </Row>
      </React.Fragment>
    );
  }

  return (
    <FormContainer property="date" title="Дата и время трансляции">
      {renderContent()}
    </FormContainer>
  );
}
